module.exports = __webpack_public_path__ + "static/media/carnoet,France.9d33f032.png";